module.exports = __webpack_public_path__ + "img/ionic-stencil.789aeaf0.svg";